import React from "react";
import { PropTypes } from 'prop-types';
import InputComponent from "./InputComponent";
import { Row, Col } from "antd";
import { LabelWrapper, RowWrapper } from "../../Step1Setup/styles";
import { MainWrapper, ErrMargin } from "../styles";
import { setSuccessorValues, jsonTemp, validationHandler,toggleStepTwoUpdateButton } from "../../actions";
import { connect } from 'react-redux';
import regexMap from "../../../../../utils/regexMap";
import { CommonInfoDerivedStates } from "../../selectors";

export const handleBlur = (props, e, successors) => {
  let reg = regexMap.emailRegEx;
  let arr = successors;
  if (arr.length > 0) {
    arr.forEach(val => {
      if (val.key === props.successorKey) {
        if (!reg.test(val.preferedEmail) && val.preferedEmail !== "") {
          val.preferedEmailError = (
            <ErrMargin>
              Email address should follow the format x@x.x
            </ErrMargin>
          );
        } else {
          val.preferedEmailError = null;
        }
      }
    });
  }
  if (props.isStep2Edit) {
    let tempData = props.tempData.tempJSON;
    if (props.contentKey === 1 || props.contentKey === 2) {
      tempData.legacyOptions[props.contentKey - 1].successorAdvisor = arr;
    } else {
      tempData.legacyOptions[
        props.contentKey - 1
      ].successionPlanGranteeOrg = arr;
    }
    props.jsonTemp({
      tempJSON: tempData
    });
  } else {
    props.setSuccessorValues({
      successorAdvisor: arr,
      key: props.contentKey,
      successorKey: props.successorKey - 1
    });
  }
};
export const handleChange = (props, e, successors) => {
  if(props.stepperUpdateIndex.status){
    props.toggleStepTwoUpdateButton(true);
  }
  let arr = successors;
  if (arr.length > 0) {
    arr.forEach(val => {
      if (val.key === props.successorKey) {
        if (e.target.value.length > 0) {
          val.preferedEmailError = null;
        }
        val.preferedEmail = e.target.value;
      }
    });
    if (props.isStep2Edit) {
      let tempData = props.tempData.tempJSON;
      if (props.contentKey === 1 || props.contentKey === 2) {
        tempData.legacyOptions[props.contentKey - 1].successorAdvisor = arr;
      } else {
        tempData.legacyOptions[
          props.contentKey - 1
        ].successionPlanGranteeOrg = arr;
      }
      props.jsonTemp({
        tempJSON: tempData,
        enableReset: true
      });
    } else {
      props.setSuccessorValues({
        successorAdvisor: arr,
        key: props.contentKey,
        successorKey: props.successorKey - 1
      });
    }
  }
};

export const EmailInfo = props => {
  let successors;
  if (props.isStep2Edit) {
    if (props.contentKey === 1 || props.contentKey === 2) {
      successors =
        props.tempData.tempJSON.legacyOptions[props.contentKey - 1]
          .successorAdvisor;
    } else {
      successors =
        props.tempData.tempJSON.legacyOptions[props.contentKey - 1]
          .successionPlanGranteeOrg;
    }
  } else {
    successors =
      props.legacy.legacyOptions[props.contentKey - 1].successorAdvisor
        .successorAdvisor;
  }
  return (
    <MainWrapper>
      <RowWrapper>
        <LabelWrapper>Email</LabelWrapper>
      </RowWrapper>
      <Row>
        <Col lg={{ span: 10 }} md={{ span: 10 }}>
          <InputComponent
           id={`email${props.successorKey}${props.contentKey}`} 
            handleBlur={e => handleBlur(props, e, successors)}
            title="Email Address (Optional)"
            placeholder="Enter email"
            data-test="enter-email"
            handleInputChange={e => handleChange(props, e, successors)}
            value={successors[props.successorKey - 1].preferedEmail}
            max={100}
          />
          {successors[props.successorKey - 1].preferedEmailError ?
            successors[props.successorKey - 1].preferedEmailError : "" }
        </Col>
      </Row>
    </MainWrapper>
  );
};

const mapStateToProps = state => ({
  legacy: state.getIn(["npaFormReducer", "legacyOptions", "legacyOptions"]),
  ...CommonInfoDerivedStates(state.toJS())
});

export const mapDispatchToProps = dispatch => ({
  setSuccessorValues: val => dispatch(setSuccessorValues(val)),
  jsonTemp: val => dispatch(jsonTemp(val)),
  validationHandler: val => dispatch(validationHandler(val)),
  toggleStepTwoUpdateButton: val => dispatch(toggleStepTwoUpdateButton(val))
})

EmailInfo.propTypes = {
  contentKey: PropTypes.number,
  isStep2Edit: PropTypes.any,
  jsonTemp: PropTypes.func,
  legacy: PropTypes.object,
  setSuccessorValues: PropTypes.func,
  stepperUpdateIndex: PropTypes.any,
  successorKey: PropTypes.string,
  tempData: PropTypes.any,
  toggleStepTwoUpdateButton: PropTypes.func,
  validationHandler: PropTypes.func,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmailInfo);
